/* eslint-disable */
import { App, ConfigProvider } from "antd";
import { Mat } from "./webparts/components/Mat";
import { RootStoreProvider } from "./webparts/components/RootStoreProvider";

const MATAppComponent = () => {
  return (
    <ConfigProvider
      theme={{
        token: {},
        components: {
          Button: {
            borderRadius: 4,
            colorPrimary: "#5a7890",
            colorPrimaryHover: "rgba(47, 75, 98, 1)",
            colorPrimaryActive: "rgba(47, 75, 98, 1)",
            colorPrimaryTextActive: "#ffffff",
          },
          Typography: {
            fontSize: 16,
          },
        },
      }}
    >
      <App>
        <RootStoreProvider>
          <Mat />
        </RootStoreProvider>
      </App>
    </ConfigProvider>
  );
};

export default MATAppComponent;